import React, { useState } from "react";
import "animate.css";
import CodeLabItem from "../components/CodeLabItem";
import data from "../sketch.json";

// Assets
// image size: 1920x1080, 1280x720, 1200x630

const CodeLab = () => {
  const [sketchData, setSketchData] = useState(data);

  return (
    <div>
      <div className="row animate__animated animate__fadeIn animate__delay-1s">
        <div className="col-md-1"></div>
        <div className="col-md-10">
          <div className="code-lab">
            <h2>Sketch Lab</h2>
            <p>EXPERIMENTS & OPEN SOURCE</p>
            <ul className="archive-items">
              {sketchData.map((data) => {
                if (!data.isHidden) {
                  return (
                    <CodeLabItem
                      key={data.id}
                      preview={data.preview}
                      tutorial={data.tutorial}
                      fork={data.fork}
                      live={data.live}
                      title={data.title}
                      prefix={data.prefix}
                      description={data.description}
                      assets={data.assets}
                      techList={data.techList}
                      posted={data.posted}
                      updated={data.updated}
                    />
                  );
                }
              })}
            </ul>
          </div>
        </div>
        <div className="col-md-1"></div>
      </div>
    </div>
  );
};

export default CodeLab;
